module.exports = __webpack_public_path__ + "static/img/Group42.bb31ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Group42.png
// module id = Gwud
// module chunks = 14